import { ContentIcon } from "@dropbox/dash-component-library";
import { EditLine } from "@dropbox/dig-icons/assets";
import type { typeahead } from "@mirage/service-typeahead-search/service/types";

import { UIIcon } from "@dropbox/dig-icons";
import { getIconProps } from "@mirage/shared/icons/FileContentIcon";
import i18n from "@mirage/translations";
import { BaseResultRow, BaseResultSplitIconTitle } from "./BaseResultRow";

export const DraftFromSourceResultRow = (props: {
  scoredResult: typeahead.ScoredDraftWithSource;
  isSelected: boolean;
}) => {
  const { scoredResult } = props;

  const { icon: iconProp } = getIconProps({
    content: scoredResult.result,
    icon: null,
    badge: null,
  });

  return (
    <BaseResultRow
      icon={
        <ContentIcon
          icon={
            <UIIcon src={EditLine} color={"var(--dig-color__text__base)"} />
          }
          size="medium"
          hasBackground={false}
        />
      }
      richTitle={
        <BaseResultSplitIconTitle
          title={i18n.t("draft_with_document_prefix")}
          icon={iconProp}
          itemTitle={scoredResult.result.title}
        />
      }
    />
  );
};
